import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCredits } from '../../contexts/CreditsContext';
import { useAuth } from '../../contexts/AuthContext';
import './CreditBalanceDisplay.css';

const CreditBalanceDisplay = ({ showLabel = true, size = 'normal' }) => {
  const navigate = useNavigate();
  const { creditBalance, isLoading, hasInitialLoad } = useCredits();
  const { isAuthenticated } = useAuth();

  // Don't show if user is not authenticated
  if (!isAuthenticated) {
    return null;
  }

  const handleClick = () => {
    navigate('/credits');
  };

  const sizeClass = size === 'small' ? 'credit-balance-small' : 'credit-balance-normal';

  const shouldShowLoading = isLoading && !hasInitialLoad;

  return (
    <div 
      className={`credit-balance-display ${sizeClass}`}
      onClick={handleClick}
      title="Click to manage credits"
    >
      {showLabel}
      <span className="credit-amount">
        {shouldShowLoading ? (
          <span className="credit-loading">...</span>
        ) : (
          <>
            <span className="credit-icon">Credits:</span>
            {creditBalance}
          </>
        )}
      </span>
    </div>
  );
};

export default CreditBalanceDisplay;